import { Entry } from '../Entry'

export function Entry20251112() {
  return (
    <Entry title="2025 Nov 12 - v3.11.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/19805/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
